import { Flex, IconButton, IconName, ProductColor, Tooltip, Typography } from '@aloft/toolkit-sui';

type Props = {
  id?: string;
  label: string;
  icon: IconName;
  isSelected: boolean;
  formItem?: boolean;
  alertCount?: number;
  onClick: () => void;
};

const formatAlertBadgeCount = (count: number): string => (count > 9 ? '9+' : String(count));

export const Tkv2ReferenceBarItem = ({
  id,
  label,
  icon,
  isSelected,
  formItem,
  alertCount,
  onClick,
}: Props) => {
  const hasAlerts = (alertCount ?? 0) > 0;
  const isAlertsItem = id === 'alerts';

  let backgroundColor: ProductColor = 'surface1';
  let borderColor: ProductColor = 'transparent';
  let iconColor: ProductColor = 'textTertiary';

  if (isSelected && isAlertsItem) {
    backgroundColor = 'alertErrorLight';
    borderColor = 'alertError';
    iconColor = 'alertError';
  } else if (isSelected) {
    if (formItem) {
      backgroundColor = 'selected5';
      borderColor = 'surfaceAccent10';
      iconColor = 'surfaceAccent10';
    } else {
      backgroundColor = 'selected4';
      borderColor = 'surfaceAccent4';
      iconColor = 'surfaceAccent4';
    }
  } else if (hasAlerts) {
    iconColor = 'alertError';
  } else if (formItem) {
    iconColor = 'surfaceAccent10';
  }

  return (
    <Flex
      backgroundColor={backgroundColor}
      borderRightWidth=".25rem"
      borderStyle="solid"
      borderRightColor={borderColor}
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Tooltip label={label} placement="left">
        <Flex position="relative">
          <IconButton
            id={id}
            ariaLabel={label}
            icon={icon}
            iconColor={iconColor}
            iconSize="lg"
            onClick={onClick}
            variant="tertiary"
            size="md"
          />
          {hasAlerts && (
            <Flex
              aria-hidden
              position="absolute"
              top="4px"
              right="8px"
              minWidth="12px"
              height="12px"
              paddingX="3px"
              borderRadius="50%"
              backgroundColor="statusOverdue"
              borderWidth="1px"
              borderStyle="solid"
              borderColor="textOffset"
              boxShadow="0 0 2px rgba(0, 0, 0, 0.04), 0 8px 8px rgba(0, 0, 0, 0.08)"
              boxSizing="border-box"
              alignItems="center"
              justifyContent="center"
              __dangerDoNotUseSx={{ pointerEvents: 'none' }}
            >
              <Typography variant="subtitle3" color="textOffset" inline>
                {formatAlertBadgeCount(alertCount ?? 0)}
              </Typography>
            </Flex>
          )}
        </Flex>
      </Tooltip>
    </Flex>
  );
};
